import { z } from 'zod';
export const ProfileVisibility = z.enum(['public', 'friends_only', 'hidden']);
export const PlayerProfilePublic = z.object({
    user_id: z.string(),
    username: z.string(),
    display_name: z.string(),
    avatar_url: z.string().nullable(),
    active_frame_id: z.string().nullable(),
    current_tier: z.enum(['bronze', 'silver', 'gold', 'platinum', 'diamond']),
    joined_relative: z.string(),
    top_contributor_count: z.number().int(),
    top_contributor_badge_tier: z.number().int(),
    active_leagues: z.array(z.object({
        game_id: z.string(),
        game_name: z.string(),
        rank: z.number().int(),
        bracket_size: z.number().int(),
    })),
    visibility: ProfileVisibility,
});
export const PlayerProfileFriend = PlayerProfilePublic.extend({
    lifetime_fever_count: z.number().int(),
    recent_big_wins: z.array(z.object({
        game_id: z.string(),
        win_level: z.string(),
        amount: z.number().int(),
        ts: z.string(),
    })),
    mutual_friends_count: z.number().int(),
});
export const PlayerProfileSelf = PlayerProfileFriend.extend({
    email: z.string().email().nullable(),
    friend_invite_code: z.string(),
    balance: z.number().int(),
    tier_points: z.number().int(),
    tier_points_reset_at: z.string().nullable(),
});
export const PlayerProfileGetRequest = z.object({
    username: z.string().optional(),
    user_id: z.string().optional(),
});
export const PlayerProfileGetResponse = z.union([PlayerProfileSelf, PlayerProfileFriend, PlayerProfilePublic]);
export const PlayerProfileUpdateRequest = z.object({
    display_name: z.string().min(1).max(24).optional(),
    username: z
        .string()
        .min(3)
        .max(20)
        .regex(/^[a-z0-9_]+$/)
        .optional(),
    avatar_url: z.string().nullable().optional(),
    active_frame_id: z.string().nullable().optional(),
    visibility: ProfileVisibility.optional(),
});
export const PlayerProfileUpdateResponse = PlayerProfileSelf;
export const PlayerCosmeticInventoryItem = z.object({
    cosmetic_id: z.string(),
    type: z.enum(['avatar_frame', 'badge', 'particle_effect', 'room_decor']),
    name: z.string(),
    asset_url: z.string(),
    thumbnail_url: z.string().nullable(),
    rarity: z.enum(['common', 'rare', 'epic', 'legendary']),
    unlocked_at: z.string(),
    source: z.string(),
});
export const PlayerCosmeticInventoryResponse = z.object({
    items: z.array(PlayerCosmeticInventoryItem),
});
//# sourceMappingURL=profile.js.map